import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public user: any = null;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    public http: HttpClient
  ) {}

  async loginByAuth({ email, password }) {}

  async registerByAuth({ email, password }) {}

  async loginByGoogle() {}

  async registerByGoogle() {}

  async loginByFacebook() {}

  async registerByFacebook() {}

  async getProfile() {}

  // logout() {
  //     localStorage.removeItem('token');
  //     localStorage.removeItem('gatekeeper_token');
  //     this.user = null;
  //     this.router.navigate(['/login']);
  // }
}
